import React from "react";

import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import TopLeftCorner from "../../shared-components/TopLeftCorner";
import TopRightCorner from "../../shared-components/TopRightCorner";
import BottomLeftCorner from "../../shared-components/BottomLeftCorner";
import BottomRightCorner from "../../shared-components/BottomRightCorner";
import ProjectsList from "./ProjectsList";

const Projects = () => {
  const matchesSm = useMediaQuery("(max-width:1280px)");

  return (
    <Grid container style={{ padding: "2.5rem", color: "#EEEEEE" }}>
      <Grid item>
        <TopLeftCorner />
        <Grid container alignItems="flex-end" style={{ height: "97.5%" }}>
          <BottomLeftCorner />
        </Grid>
      </Grid>

      <Grid item lg md sm xs style={{ margin: "3rem 0" }}>
        <h1 style={{ marginBottom: "8rem" }} className="projects-title">
          # Have a look at{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#222831",
              backgroundColor: "#EEEEEE",
            }}
          >
            all
          </span>{" "}
          of my projects
        </h1>

        <ProjectsList />

        <h1
          style={{
            textAlign: "center",
            marginBottom: "4rem",
            paddingTop: "3rem",
          }}
        >
          Woah! You made it all the way here ...
        </h1>
        <h1
          style={
            matchesSm
              ? { margin: "0 3rem 1rem", textAlign: "center" }
              : { textAlign: "center" }
          }
        >
          Like my work?{" "}
          <Link to="/contact" style={{ color: "#FAFF00" }}>
            Let’s have a chat!
          </Link>
        </h1>
      </Grid>

      <Grid item>
        <TopRightCorner />
        <Grid container alignItems="flex-end" style={{ height: "97.5%" }}>
          <BottomRightCorner />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Projects;
